
export class CarouselItem {
  src: string;
  thumb: string;
  alt: string;
}
